export const CircularGraph = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="224" height="224" viewBox="0 0 224 224" fill="none">
    <path
      d="M224 112C224 93.608 219.471 75.499 210.812 59.2726C202.153 43.0462 189.632 29.2019 174.354 18.9625C159.076 8.72304 141.511 2.40367 123.212 0.56257C104.912 -1.27853 86.4405 1.41529 69.4289 8.40609L112 112H224Z"
      fill="#C5A6EE"
    />
    <path
      d="M72.1067 7.34568C46.354 17.1624 25.125 36.1297 12.4814 60.6186C-0.162212 85.1075 -3.33262 113.398 3.57679 140.079C10.4862 166.759 26.9902 189.955 49.9312 205.228C72.8722 220.502 100.639 226.78 127.92 222.863L112 112L72.1067 7.34568Z"
      fill="#EDE981"
    />
    <path
      d="M127.778 222.883C145.272 220.394 161.93 213.8 176.389 203.641C190.848 193.482 202.697 180.046 210.97 164.431L112 112L127.778 222.883Z"
      fill="#83ACEA"
    />
    <path d="M210.965 164.44C219.677 147.998 224.156 129.645 223.996 111.038L112 112L210.965 164.44Z" fill="#FA9A9A" />
  </svg>
);
